import { VueConstructor } from "vue";
import { Store } from "vuex";

// apis
import { Configs } from "@/types";
import createApis from "@foxone/api";

// third party libs
import infiniteScroll from "vue-infinite-scroll";
import VueClipboard from "vue-clipboard2";
import VueMeta from "vue-meta";
import VueGtag from "vue-gtag";
import Bugsnag from "@bugsnag/js";
import VueI18n from "vue-i18n";
import BugsnagPluginVue from "@bugsnag/plugin-vue";

import Bridge from "./bridge";
import icons from "./icons";
import utils from "@/utils";

import { CONFIGS, ROOT_EVENTS } from "@/constants";

export interface ApiUseOptions {
  configs: Configs;
  store: Store<any>;
}

export default function(Vue: VueConstructor, options: ApiUseOptions) {
  Vue.use(VueClipboard);
  Vue.use(infiniteScroll);
  Vue.use(VueMeta);
  Vue.use(VueI18n);

  if (CONFIGS.GA) {
    Vue.use(VueGtag, {
      config: { id: CONFIGS.GA }
    });
  }

  if (CONFIGS.BUGSNAG) {
    Bugsnag.start({
      apiKey: CONFIGS.BUGSNAG,
      plugins: [new BugsnagPluginVue(Vue as any)]
    });
  }

  const apis = createApis(options);
  const bridge = new Bridge();

  Vue.prototype.$icons = icons;
  Vue.prototype.$api = apis;
  Vue.prototype.$bridge = bridge;
  Vue.prototype.$common = {
    utils,
    configs: CONFIGS
  };
  Vue.prototype.$helper = utils.helper;
  Vue.prototype.$rootEvents = ROOT_EVENTS;

  options.store.$api = apis;
  options.store.$common = {
    utils,
    configs: CONFIGS
  };
}

declare module "vue/types/vue" {
  export interface Vue {
    $icons: typeof icons;
    $bridge: Bridge;
    $api: ReturnType<typeof createApis>;
    $rootEvents: typeof ROOT_EVENTS;
    $common: { utils: typeof utils; configs: typeof CONFIGS };
    $helper: typeof utils.helper;
  }
}

declare module "vuex/types/index" {
  interface Store<S> {
    $api: ReturnType<typeof createApis>;
    $common: { utils: typeof utils; configs: typeof CONFIGS };
  }
}
